<template>
    <div class="pb-5">
        <az-toolbar>
            <az-call-to-action v-if="podeAtualizarComissao" active slot="actions" css-class="no-mobile" @click="novo" v-az-auth="'Comissao.Atualizar'">
                <v-icon>add_circle</v-icon>
                Novo
            </az-call-to-action>
            <az-search slot="simpleSearch"
                       :filter="filtrosAtivos"
                       @simple-search="eventoBuscaSimples"
                       @remove-filter="eventoRemoverFiltro"
                       simple-search-placeholder="Informe o nome ou sigla">
            </az-search>
        </az-toolbar>
        <comissao-busca-tabela :itens="itens"
                               :paginas="paginas" :total-itens="totalItens"
                               :paginacao="$store.state.comissaoBusca.paginacao"
                               :exibirBtnEdicao="podeAtualizarComissao"
                               @editar="eventoEditar"
                               @visualizar="eventoVisualizar"
                               @paginar="eventoPaginar"
        />
    </div>
</template>

<script>
import _ from 'lodash'
import {mapActions, mapState} from 'vuex'
import {actionTypes, mutationTypes} from '@/commons/constants'
import {filters} from '@azinformatica/loki'
import ComissaoBuscaTabela from './ComissaoBuscaTabela'
import LicitacaoBuscaTabela from "@/views/licitacao/busca/LicitacaoBuscaTabela.vue";

export default {
        components: {LicitacaoBuscaTabela, ComissaoBuscaTabela},
        data() {
            return {
                filtrosInterno: _.cloneDeep(this.$store.state.comissaoBusca.filtros),
                itens: [],
                paginas: 0,
                totalItens: 0,
                podeAtualizarComissao: false
            }
        },
        computed: {
            ...mapState(['comissaoBusca']),
            filtrosAtivos() {
                const filtros = _.cloneDeep(this.comissaoBusca.filtros)
                const filtrosAtivos = {}
                for (let [chave, val] of Object.entries(filtros)) {
                    if (filtros[chave].value) {
                        val.valueTruncated = filters.azTitleCase(val.value, 10)
                        filtrosAtivos[chave] = val
                    }
                }
                return filtrosAtivos
            }
        },
        created() {
          this.resetarPaginacao()
        },
        async mounted() {
            this.validarExibirBotaoNovaComissao()
            await this.buscar()
        },
        methods: {
            ...mapActions([actionTypes.BUSCAR_COMISSOES_APURACAO_PAGINADO]),
            validarExibirBotaoNovaComissao(){
                this.podeAtualizarComissao = this.$route.name !== 'comissoesBuscaVisualizacao'
            },
            resetarPaginacao(){
                this.$store.commit(mutationTypes.SET_RESETAR_PAGINACAO)
            },
            async buscar() {
                this.$store.commit(mutationTypes.SET_FILTROS_BUSCA_COMISSAO, _.cloneDeep(this.filtrosInterno))
                this.setMensagemLoading('Carregando Comissões...')
                const resultado = await this.buscarComissoesApuracaoPaginado()
                if(resultado){
                  this.itens = resultado.items
                  this.paginas = resultado.totalPages
                  this.totalItens = resultado.totalElements
                }
            },
            async eventoBuscaSimples(valor) {
                this.filtrosInterno.descricaoSigla.value = valor
                await this.buscar()
            },
            async eventoLimpar() {
                this.$store.commit(mutationTypes.LIMPAR_FILTROS_BUSCA_COMISSAO)
                this.filtrosInterno = _.cloneDeep(this.$store.state.comissaoBusca.filtros)
                await this.buscar()
            },
            async eventoRemoverFiltro(propriedade) {
                if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                    this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
                }
                await this.buscar()
            },
            async eventoPaginar(paginacao) {
                this.$store.commit(mutationTypes.SET_PAGINACAO_BUSCA_COMISSAO, paginacao)
                await this.buscar()
            },
            eventoEditar(comissaoId) {
                this.$router.push({name: 'comissaoAtualizacao', params: {id: comissaoId}, query: {edicao: true}})
            },
            eventoVisualizar(comissaoId) {
                if(this.$route.name === 'comissoesBuscaVisualizacao'){
                    this.$router.push({name: 'comissaoVisualizacao', params: {id: comissaoId}})
                }else{
                    this.$router.push({name: 'comissaoAtualizacao', params: {id: comissaoId}})
                }
            },
            novo() {
                this.$router.push({name: 'comissaoNovo'})
            }
        }
    }
</script>
